/**
 * 5.1.2 내부 네트워크 설정 Store
 *
 * @since 2017-12-12
 * @author devp020
 */

export const state = () => ({
  url: '/api/pm/int-net',
  ipUrl: '/api/pm/int-net/ip',
  networkId: '',
  ipList: [],
  internalNetworkList: [],
  internalNetworkResult: null,
  putInternalNetworkResult: null,
  errorMessage: null,
  tableCondition: {
    selectedRowData: false
  }
})

export const mutations = {
  // 내부 네트워크 설정 조회
  mutInternalNetwork (state, payload) {
    state.internalNetworkList = payload
  },
  // 내부 네트워크 설정 추가
  mutPostInternalNetwork (state, payload) {
    state.internalNetworkResult = payload
  },
  // 내부 네트워크 설정 수정
  mutPutInternalNetwork (state, payload) {
    state.putInternalNetworkResult = payload
  },
  // 내부 네트워크 설정 삭제
  mutDelInternalNetwork (state, payload) {
    state.internalNetworkResult = payload
  },
  mutationErrorMessage (state, payload) {
    state.errorMessage = payload
  },
  getNetworkId (state, payload) {
    state.networkId = parseInt(payload.msg)
  },
  getNetworkIp (state, payload) {
    state.ipList = payload
  },
  clearNetworkIp (state) {
    state.ipList = []
  }
}

export const actions = {
  // 내부 네트워크 설정 빈 설정 (추가시 빈 id 조회)
  async getNetworkId ({commit, state}) {
    try {
      const data = await this.$axios.$post(`${state.url}`, null, {successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }

      commit('getNetworkId', data.result)
      commit('getNetworkIp', [])
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },

  // 내부 네트워크 아이피 조회
  async getNetworkIp ({commit, state}, payload) {
    try {
      const data = await this.$axios.$get(`${state.ipUrl}/${payload}`, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('getNetworkIp', data.result)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },

  // 내부 네트워크 설정 조회
  async acsInternalNetwork ({commit, state}) {
    try {
      const res = await this.$axios.$get(`${state.url}/0`)
      if (res.code === 'ok') {
        commit('mutInternalNetwork', res.result)
      } else {
        commit('mutInternalNetwork', [])
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 내부 네트워크 아이피 추가
  async addNetworkIp ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(`${state.ipUrl}`, payload, {successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 내부 네트워크 아이피 삭제
  async delNetworkIp ({commit, state}, payload) {
    let isMulty = false
    if (payload.length > 1) {
      isMulty = true
    }
    const idSet = []
    for (const item of payload) {
      idSet.push(item.policy_mng_int_net_ip_id)
    }
    const idList = {'policy_mng_int_net_ip_id_list': idSet}
    try {
      const data = await this.$axios.$put(`${state.ipUrl}/multi`, idList, {successAlert: false})
      if (data.code !== 'ok') {
        if (isMulty) {
          return {code: 'pok', errors: data.result.msg}
        }
        return {code: 'nok', errors: data.result.msg}
      }
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 내부 네트워크 아이피 예외설정
  async exceptNetworkIp ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.ipUrl}/${payload}`, null, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 내부 네트워크 설정 추가
  async setInternalNetwork ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.url}`, payload, {successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 내부 네트워크 설정 수정
  async acsPutInternalNetwork ({commit, state}, payload) {
    const result = { error: null }
    try {
      const res = await this.$axios.$put(`${state.url}/${payload.policy_mng_int_net_id}`, payload)
      commit('mutPutInternalNetwork', res)
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 내부 네트워크 설정 삭제
  async acsDelInternalNetwork ({commit, state}, payload) {
    let isMulty = false
    if (payload.length > 1) {
      isMulty = true
    }
    const idSet = []
    for (const item of payload) {
      idSet.push(item.policy_mng_int_net_id)
    }
    const idList = {'policy_mng_int_net_id_list': idSet}
    try {
      const data = await this.$axios.$put(`${state.url}/multi`, idList, {successAlert: false})
      if (data.code !== 'ok') {
        if (isMulty) {
          return {code: 'pok', errors: data.result.msg}
        }
        return {code: 'nok', errors: data.result.msg}
      }
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.url}/${type}`, null, msg)
      if (data.code !== 'ok') {
        return false
      }
      this.dispatch(`common/common/setIsChanged`, false)
      return 'ok'
    } catch (error) {
      return error
    }
  }
}
export const getters = {}
export const strict = false
